<div class="base_footer">
    <div class="container-fluid">
        <div class="d-md-flex flex-wrap flex-lg-row justify-content-between align-items-center">
            <div class=" ">
                <!-- Co-brand: "Powered by" sits on the address line, so the footer stays one line tall. -->
                <div class="footer-text align-items-center flex-wrap">
                    <p class="fw-normal">{{ coBrand.footerText('Real World finance inc - 131 continental dr, ste 301, newark, DE 19713, USA.') }}</p>
                    <p class="rw-powered-by rw-powered-by--footer" *ngIf="coBrand.brand">Powered by <b>RealWorld.fi</b></p>
                </div>
            </div>
                
            <div class="d-flex flex-column flex-md-row gap-md-3">
                <div class="d-flex align-items-center justify-content-lg-center gap-2">
                    <!-- <p><i class="bi bi-envelope-fill fs-6"></i> <a href="mailto:info&#64;realworld.fi">info&#64;realworld.fi</a></p> -->
                    <ul class="social-links">
                        <li><a href="mailto:info&#64;realworld.fi"><i class="bi bi-envelope-fill fs-6"></i></a></li>
                        <li><a href="https://discord.com/invite/6xEX48jsVX" target="_blank" rel="noopener"><em
                                    class="bi bi-discord fs-6"></em></a></li>
                        <li><a href="https://twitter.com/realworld_fi" target="_blank" rel="noopener"><em
                                    class="bi bi-twitter-x fs-6"></em></a></li>
                        <li><a href="https://www.linkedin.com/company/real-world-finance/" rel="noopener"
                                target="_blank"><em class="bi bi-linkedin fs-6"></em></a></li>
                        <!-- Audit badge: links to our CertiK Skynet page as proof of the audit. -->
                        <li class="certik-badge"><a href="https://skynet.certik.com/projects/realworld-fi" target="_blank"
                                rel="noopener" title="Audited by CertiK"
                                aria-label="Audited by CertiK, view RealWorld.fi on CertiK Skynet"><span
                                    class="certik-logo" aria-hidden="true"
                                    style="--certik-logo: url(assets/images/certik-logomark.png)"></span></a></li>
                    </ul>
                </div>
                <div class="d-flex align-items-center justify-content-start justify-content-lg-end gap-2 legal-links">
                    <a href="{{docUrl?.['privacy-policy_url']}}" target="_blank" rel="noopener">Privacy
                        policy.</a>
                    <a>|</a>
                    <a href="{{docUrl?.['user-agreement_url']}}" target="_blank" rel="noopener">Terms & conditions.</a>
                </div>
            </div>

        </div>
    </div>
     <!-- <div class="backtotop" (click)="bottomtotop()" *ngIf="!onboardPage">
        <em class="bi bi-arrow-up"></em>
    </div> -->
</div>